import React from 'react';
import { Visibility } from '@mui/icons-material';
import { Stack } from '@mui/material';

import { ReusableTransformType } from '@nexla/@types';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';

type Props = {
  key: string;
  itemKey: string;
  itemData: ReusableTransformType | { name: string; id?: number };
  onSelect: (item: ReusableTransformType | { name: string; id?: number }) => void;
};

function AttributeTransformItem(props: Props) {
  const { itemKey, itemData, onSelect } = props;

  return (
    <>
      {itemData && !itemData.id ? (
        <li key={itemKey} className="item current-one">
          <div className="item-label">
            <div className="icon-box" />
            <span className="title">{itemData?.name}</span>
          </div>
        </li>
      ) : (
        <li
          key={itemKey}
          className={itemKey === 'item_transform_list_current' ? 'item current-one' : 'item'}
        >
          <div className="item-label show-hover" onClick={() => onSelect(itemData)}>
            <div className="icon-box">
              <Visibility />
            </div>
            <span className="title">{itemData?.name}</span>
          </div>
          <Stack direction="row" spacing="16px" alignItems="center" className="chips">
            <ChipWithCopy toCopy={`${itemData?.id}`}>ID {itemData?.id}</ChipWithCopy>
            {itemData?.public && <span className="public-label">Public</span>}
          </Stack>
        </li>
      )}
    </>
  );
}

export default AttributeTransformItem;
